import React from 'react';

import classnames from "classnames";
import styles from "../../styles/game-info-module.module.scss";


export const GameInfoModuleRowPlaceholder = () => {
  return (
    <div className={classnames(styles.placeholder_row)}>
      <div className={classnames(styles.placeholder_bullet)}></div>
      <div className={classnames(styles.placeholder_key)}></div>
      <div className={classnames(styles.placeholder_value)}></div>
    </div>
  )
}
